import React from "react";
import DashboardLayout from "../../../molecules/DashboardLayout";
import { PaymentTypesModule } from "../../../modules/PaymentTypes";

const PaymentTypes = () => {
  return (
    <DashboardLayout>
      <PaymentTypesModule />
    </DashboardLayout>
  );
};

export default PaymentTypes;
